import { render, staticRenderFns } from "./MemberForm.vue?vue&type=template&id=2cbc059c&scoped=true"
import script from "./MemberForm.vue?vue&type=script&lang=js"
export * from "./MemberForm.vue?vue&type=script&lang=js"
import style0 from "./MemberForm.vue?vue&type=style&index=0&id=2cbc059c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc059c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cbc059c')) {
      api.createRecord('2cbc059c', component.options)
    } else {
      api.reload('2cbc059c', component.options)
    }
    module.hot.accept("./MemberForm.vue?vue&type=template&id=2cbc059c&scoped=true", function () {
      api.rerender('2cbc059c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/MemberForm.vue"
export default component.exports